import React, {useState} from "react";

// UI
import MaterialTable from "@material-table/core";
import _ from "lodash";

// Table Params
import { OPTIONS, LOCALIZATION, getColumns } from "./Params/KCCTintometersSurveys";
import { tableIcons } from "../../ui-components/TableIcons";
import TableStyle from "../TableStyle";
import { flattenTintometersData } from "./Params/common";
import Modal from "../../ui-components/Modal";
import Spinner from "../../ui-components/Spinner";


function KCCTintometersSurveysTable({ intl, countryCode, colors, surveys, deleteSurveyCallbackFn}) {

  // state
  const [surveyIdToDelete, setSurveyIdToDelete] = useState(null);
  const [surveyDeletionLoading, setSurveyDeletionLoading] = useState(false);

  // utilities
  const flatData = flattenTintometersData(surveys);

  // FIXME this table throws a warning since it's reloaded two times (one when colors are loaded, the other when surveys
  //  are loaded) having the same rows. We must find a way to resolve this
  return <>
    <TableStyle>
      <MaterialTable
        columns={getColumns(intl, countryCode, colors, setSurveyIdToDelete)}
        data={flatData ?? []}
        icons={tableIcons}
        isLoading={!surveys}
        parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
        options={OPTIONS}
        localization={LOCALIZATION}
        pagination
      />
    </TableStyle>
    {
      surveyIdToDelete && (
        <Modal
          type="warning"
          title={intl.formatMessage({id: 'delete_survey_title'})}
          onDismiss={() => { setSurveyIdToDelete(null); }}
          onExit={() => { setSurveyIdToDelete(null); }}
          onConfirm={async () => {
            setSurveyDeletionLoading(true);
            await deleteSurveyCallbackFn(
              surveyIdToDelete,
              () => {
                setSurveyDeletionLoading(false);
                setSurveyIdToDelete(null);
              }
            );
          }}
          confirmText={
            !surveyDeletionLoading
              ? intl.formatMessage({id: 'confirm'})
              : <div className="relative w-full h-full"><Spinner /></div>
          }
          dismissText={intl.formatMessage({id: 'cancel'})}
        />
      )
    }
  </>;
}

export default React.memo(KCCTintometersSurveysTable, (props, nextProps) => {
  // Render component only when users changes
  return _.isEqual(props.colors, nextProps.colors) && _.isEqual(props.surveys, nextProps.surveys);
});
